<template>
  <div v-if="visible && ad.imageUrl" class="popup-ad-container">
    <div class="popup-ad-wrap">
      <div class="popup-ad-close-btn" @click="handleClose">×</div>
      <transition name="fade" mode="out-in">
        <a v-if="ad.linkUrl" :href="ad.linkUrl" target="_blank" :key="currentIndex">
          <img :src="ad.imageUrl" class="popup-ad-image" alt="广告" />
        </a>
        <img v-else :src="ad.imageUrl" class="popup-ad-image" alt="广告" :key="currentIndex" />
      </transition>
      <div v-if="ads.length > 1" class="popup-ad-indicator">
        <span
            v-for="(item, index) in ads"
            :key="index"
            :class="['popup-indicator-dot', { active: index === currentIndex }]"
            @click="currentIndex = index"
        ></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import api from '@/api'

const visible = ref(true)
const ads = ref([])
const currentIndex = ref(0)
let timer = null

const ad = computed(() => ads.value[currentIndex.value] || {})

const handleClose = () => {
  visible.value = false
}

const startRotation = () => {
  if (ads.value.length > 1) {
    timer = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % ads.value.length
    }, 5000)
  }
}

onMounted(() => {
  api.advertisement.getByPosition('login_popup').then(({ data }) => {
    if (data && data.length > 0) {
      ads.value = data
      startRotation()
    }
  })
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style scoped>
.popup-ad-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}
.popup-ad-wrap {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
}
.popup-ad-close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background: rgba(0,0,0,0.55);
  color: #fff;
  text-align: center;
  line-height: 28px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
}
.popup-ad-close-btn:hover {
  background: #000;
}
.popup-ad-image {
  width: 300px;
  max-height: 400px;
  display: block;
  object-fit: cover;
}
.popup-ad-indicator {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 2;
}
.popup-indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}
.popup-indicator-dot.active {
  background: #fff;
  transform: scale(1.2);
}
.popup-indicator-dot:hover {
  background: rgba(255, 255, 255, 0.8);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
@media screen and (max-width: 768px) {
  .popup-ad-container {
    bottom: 10px;
    right: 10px;
  }
  .popup-ad-image {
    width: 200px;
    max-height: 280px;
  }
}
</style>